const textHelpers = {

  replaceNewlineWithHtmlTags<T>(text: string) {
    if (!text) return '';
    return text.replace(/(?:\r\n|\r|\n)/g, '<br>');
  },

};

export default textHelpers;
